<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 20 20"
  >
    <path
      fill="currentColor"
      d="m13 14.3-1.4-1.5 2.7-2.8-2.7-2.8L13 5.7l2.7 2.8 2.7-2.7L20 7.2 17.3 10l2.7 2.8-1.5 1.4-2.7-2.7zM0 5.8v8.4h3.3L9.2 20V0L3.3 5.8z"
    />
  </svg>
</template>
